const BUCKET = import.meta.env.VITE_SUPABASE_STORAGE_BUCKET || 'cms-uploads';

export function getStoragePublicUrl(storagePath: string): string {
  const base = import.meta.env.VITE_SUPABASE_URL;
  if (!base) return storagePath;
  const clean = storagePath.replace(/^\/+/, '');
  return `${base}/storage/v1/object/public/${BUCKET}/${clean}`;
}

/** Resolve CMS image paths — supports legacy /upload/* and full Supabase URLs */
export function resolveMediaUrl(src: string | null | undefined): string {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/upload/')) {
    return getStoragePublicUrl(src.replace(/^\/upload\//, ''));
  }
  return src;
}

export function isSupabaseStorageUrl(src: string): boolean {
  const base = import.meta.env.VITE_SUPABASE_URL;
  if (!base) return false;
  return src.startsWith(`${base}/storage/`);
}

export function getStorageBucket() {
  return BUCKET;
}
